export default function CDNLink(path: string): string {
  const host = import.meta.env.VITE_CDN_HOST as string;
  return `${host}/${path}`;
}
